module.exports = ".header-card {\n  margin-left: 5px;\n  margin-bottom: 10px; }\n\n.card-margin {\n  margin: 5px; }\n\n.card-compact {\n  padding: 5px; }\n\n.card-compact h4 {\n  margin: 5px; }\n\n.botton-margin {\n  margin-bottom: 10px; }\n\n.float-button {\n  position: fixed;\n  text-align: center;\n  padding: 30px;\n  bottom: 15px;\n  right: 15px; }\n\n.button-container {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/users/user-form/user-form.component.scss
// module id = ./src/app/admin/users/user-form/user-form.component.scss
// module chunks = main